<template>
  <div class="custom-w">
    <div style="padding-left: 12px">
      <el-link class="back" :underline="false" v-on:click="() => {this.$router.go(-1)}">
        <img :alt="`<`" :src="require(`../../assets/image/ic_back.svg`)">
        返回
      </el-link>
    </div>
    <Info :area="area"/>
  </div>
</template>

<script>
import { getLogoSrc, getTagStyle, releaseItem } from "@/views/common/utils";
import Info from "@/views/detail/Info";

export default {
  name: "Detail",
  components: { Info },
  props: {
  },
  data() {
    return {
      getLogoSrc: getLogoSrc,
      getTagStyle: getTagStyle,
      url: '/package/release/',
      releaseItems: [releaseItem],
    }
  },
  methods: {
  },
  mounted() {
  },
  computed: {
    hasItem() {
      try {
        return this.releaseItems[0].id;
      } catch {
        return false;
      }
    },
    area() {
      return this.$router.currentRoute.path.indexOf("/en") === -1 ? "China" : "Overseas";
    }
  },
}
</script>

<style lang="scss" scoped>
.back {
  height: 22px;
  font-size: 16px;
  color: #666666;

  img {
    height: 12.6px;
  }
}
</style>
